import { CtaButton, Spinner, theme } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  padding: 0;
  flex-direction: column;
`;

export const StyledBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem;
`;

export const IllustrationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: 20rem;
  width: 21rem;
  @media only screen and (min-width: 768px) {
    height: 24rem;
    width: 25rem;
  }
  @media only screen and (min-width: 1280px) {
    height: 24rem;
    width: 25rem;
  }
`;

export const StyledButton = styled.button`
  background: ${theme.colors.tenant.main};
  padding: 0.5rem 1.5rem;
  border: 0;
  border-radius: 0.5rem;
  color: #fff;
  &:hover {
    cursor: pointer;
    background: ${theme.colors.tenant.mainAlternate};
  }
  &:disabled {
    cursor: not-allowed;
    background: ${theme.colors.cross.silverFox};
  }
  @media only screen and (min-width: 768px) {
    padding: 0.7rem 2rem;
  }
  @media only screen and (min-width: 1280px) {
    padding: 0.8rem 3rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; // Aligns children (button) to the right
`;

export const StyledContinueButton = styled(CtaButton).attrs({
  tag: 'button',
  user: 'tenant',
})`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${rem('10px')};
  text-transform: uppercase;
  margin: 0;

  span {
    position: relative;
  }

  &:hover {
    color: ${({ theme, variant }) =>
      variant === 'secondary' && theme.colors.tenant.mainAlternate};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: ${rem('150px')};
    width: 100%;
  }
`;

export const StyledSpinner = styled(Spinner)`
  margin-right: ${rem('5px')};
`;
